import { render, staticRenderFns } from "./TodosList.vue?vue&type=template&id=bfc23de8&scoped=true&"
import script from "./TodosList.vue?vue&type=script&lang=js&"
export * from "./TodosList.vue?vue&type=script&lang=js&"
import style0 from "./TodosList.vue?vue&type=style&index=0&id=bfc23de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc23de8",
  null
  
)

export default component.exports